import { create } from "zustand";

/**
 * Which chat's Helpers sheet is open. One sheet, two ways in: the topbar chip
 * and the note under the latest reply. `opener` is the button that opened it,
 * so closing puts focus back where the tap came from.
 */
interface HelpersSheetState {
  companyId: string | null;
  opener: HTMLElement | null;
  open: (companyId: string, opener?: HTMLElement | null) => void;
  close: (restoreFocus?: boolean) => void;
}

export const useHelpersSheet = create<HelpersSheetState>((set, get) => ({
  companyId: null,
  opener: null,
  open: (companyId, opener = null) => set({ companyId, opener }),
  close: (restoreFocus = true) => {
    const { opener } = get();
    set({ companyId: null, opener: null });
    if (!restoreFocus || typeof document === "undefined") return;
    requestAnimationFrame(() => {
      const target = opener?.isConnected ? opener : document.querySelector<HTMLElement>(".helpersChip");
      target?.focus({ preventScroll: true });
    });
  },
}));
